import ContactUs3Container from "../../../components/pages/other/ContactUs3";

const ContactUs3 = () => {
  return <ContactUs3Container />;
};

export default ContactUs3;
